import { useState } from "react";
import TooltipWrapper from "./ui-control/TooltipWrapper";
import XModal from "./common/XModal";
import { getSafeImageUrl } from "../utils/securityUtil";
import { cn } from "../utils/classNames";

const HeadshotViewer = ({
    headshot,
    imgClassName = "w-10 h-10 shrink-0"
}) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!headshot?.url) return null;

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const headshotUrl = getSafeImageUrl(headshot.url, "/placeholder.png");

    return (
        <>
            <TooltipWrapper
                showTooltip={true}
                title="Click to larger view"
                variant="message"
            >
                <img
                    src={headshotUrl}
                    alt="Headshot"
                    className={cn("rounded-full object-cover cursor-pointer", imgClassName)}
                    onClick={handleOpen}
                />
            </TooltipWrapper>

            <XModal
                isOpen={isOpen}
                title={headshot?.name}
                onClose={handleClose}
                size="lg"
            >
                <img
                    src={headshotUrl}
                    alt="Headshot"
                    className="img-fluid mx-auto! block!"
                />
            </XModal>
        </>
    );
};

export default HeadshotViewer;